export default __webpack_public_path__ + "static/media/Clip_path_group1.dd2eb350.png";